(() => {
  const heroVideo = document.querySelector('[data-ba-hero-video]');
  if (heroVideo) {
    const hero = heroVideo.closest('.ba-catalog__hero');
    heroVideo.muted = true;
    heroVideo.playsInline = true;
    heroVideo.autoplay = true;
    heroVideo.loop = true;

    const markVideoReady = () => {
      if (heroVideo.readyState >= 2) {
        hero?.classList.add('is-video-ready');
      }
    };

    const playHeroVideo = () => {
      markVideoReady();
      const playPromise = heroVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };

    heroVideo.addEventListener('loadeddata', markVideoReady);
    heroVideo.addEventListener('canplay', playHeroVideo);
    heroVideo.load();
    playHeroVideo();
    window.setTimeout(playHeroVideo, 800);

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden && heroVideo.paused) {
        playHeroVideo();
      }
    });
  }

  const search = document.querySelector('[data-ba-floating-search]');
  if (!search) return;

  const input = search.querySelector('.ba-floating-search__input');
  const grid = document.querySelector('#catalog-grid');
  const groups = grid
    ? {
        available: grid.querySelector('[data-ba-product-group="available"]'),
        soldOut: grid.querySelector('[data-ba-product-group="sold-out"]'),
      }
    : {};
  const cards = grid ? [...grid.querySelectorAll('[data-ba-product-card]')] : [];
  const names = [...search.querySelectorAll('.ba-floating-search__names span')]
    .map((item) => item.textContent.trim())
    .filter(Boolean);

  cards.forEach((card) => {
    card.querySelectorAll('video, .ba-masonry__video').forEach((video) => {
      video.pause?.();
      video.remove();
    });
  });

  if (!input || names.length === 0) return;

  let index = 0;
  const originalOrder = new Map(cards.map((card, cardIndex) => [card, cardIndex]));
  const isSoldOut = (card) => Boolean(card.querySelector('.ba-masonry__badge'));
  const setSearching = (isSearching) => {
    Object.values(groups).forEach((group) => group?.classList.toggle('is-searching', isSearching));
  };

  const normalize = (value) => value.toLowerCase().trim().replace(/\s+/g, ' ');
  const singularize = (value) => value.replace(/s\b/g, '');

  const getScore = (card, query) => {
    const haystack = singularize(card.dataset.baSearch || card.textContent || '');
    const terms = singularize(query).split(' ').filter(Boolean);
    if (terms.length === 0) return 0;

    let score = 0;
    terms.forEach((term) => {
      if (haystack.includes(term)) score += 1;
    });

    if (haystack.includes(singularize(query))) score += 2;
    return score;
  };

  const reorderGrid = () => {
    if (!grid || cards.length === 0) return;

    const query = normalize(input.value);
    if (!query) {
      setSearching(false);
      cards
        .sort((a, b) => originalOrder.get(a) - originalOrder.get(b))
        .forEach((card) => {
          card.classList.remove('is-search-muted');
          const group = isSoldOut(card) ? groups.soldOut : groups.available;
          group?.append(card);
        });
      return;
    }

    setSearching(true);
    const rankedCards = cards
      .map((card) => ({
        card,
        score: getScore(card, query),
        index: originalOrder.get(card),
      }))
      .sort((a, b) => b.score - a.score || a.index - b.index);

    rankedCards
      .filter(({ card }) => !isSoldOut(card))
      .forEach(({ card, score }) => {
        card.classList.toggle('is-search-muted', score === 0);
        groups.available?.append(card);
      });

    rankedCards
      .filter(({ card }) => isSoldOut(card))
      .forEach(({ card, score }) => {
        card.classList.toggle('is-search-muted', score === 0);
        groups.soldOut?.append(card);
      });
  };

  const updatePlaceholder = () => {
    input.placeholder = `Search ${names[index]}`;
    index = (index + 1) % names.length;
  };

  updatePlaceholder();
  window.setInterval(updatePlaceholder, 2200);

  input.addEventListener('input', reorderGrid);

  search.addEventListener('submit', (event) => {
    event.preventDefault();
    if (input.value.trim() === '') {
      input.value = names[(index + names.length - 1) % names.length];
    }
    reorderGrid();
    document.querySelector('#catalog-grid')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
